
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import CheckInSuccessfull from "@/assets/clock.png"
import Logo from "@/assets/dashboard-svg.svg"
import { formatToPKR } from "@/lib/helper"
import { CheckInResponse } from "@/types/user"

interface CheckInLogsProps {
    checkInInfo: CheckInResponse,
    name: string
}
const CheckInLogs = ({ checkInInfo, name }: CheckInLogsProps) => {
    const { contract_end_in_days, outstanding_invoices, remaining_credits } = checkInInfo as CheckInResponse
    return (
        <div className="w-full p-3 pt-0 flex flex-col gap-4">
            <div className="flex items-start justify-between ">
                <img src={Logo} alt="Check In Succesfull" className={`w-14 h-14 `} />

                <div className="flex items-center justify-center gap-6 ">
                    <img src={CheckInSuccessfull} alt="Check In Succesfull" className="w-16 h-16" />
                    <div>
                        <p className="font-medium text-base">Check In Successfully!</p>
                        <p className="text-sm">You're checked in! Let’s make this session count.</p>
                    </div>
                </div>

                <div></div>
            </div>

            {/* Membership Plan Alert */}
            {contract_end_in_days.length > 0 && <div className="border border-amber-200 bg-amber-50 rounded-md p-2.5 w-fit mx-auto">
                <h3 className="text-amber-800 font-medium text-sm mb-0.5">Membership Plan</h3>
                <div className="text-amber-700 text-xs">
                    {contract_end_in_days.map((message, index) => (
                        <p>{message}</p>
                    ))}
                </div>
            </div>}

            {/* Remaining Credits */}
            <div className="border rounded-md">
                <div className="px-3 py-2 border-b">
                    <h2 className="text-sm font-medium text-gray-700">Remaining Credits</h2>
                </div>
                <div className="px-3 py-2 flex justify-between items-center">
                    <div className="text-xs text-gray-600">Name: <span className="capitalize">{name}</span></div>
                    {remaining_credits?.count as number > 0 && <div className="text-xs text-gray-600">Credits: {remaining_credits?.count as number}</div>}
                </div>
            </div>

            {/* Due Invoices */}
            {outstanding_invoices.length > 0 && <div className="border rounded-md flex-1 overflow-hidden flex flex-col">
                <div className="px-3 py-2 border-b">
                    <h2 className="text-sm font-medium text-gray-700">Due Invoices</h2>
                </div>
                <div className="overflow-auto flex-1">
                    <Table>
                        <TableHeader>
                            <TableRow className="bg-gray-50">
                                <TableHead className="text-gray-600 font-medium text-xs py-2">Date</TableHead>
                                <TableHead className="text-gray-600 font-medium text-xs py-2 text-right">Discount </TableHead>
                                <TableHead className="text-gray-600 font-medium text-xs py-2 text-right">Tax </TableHead>
                                <TableHead className="text-gray-600 font-medium text-xs py-2 text-right">Total Amount</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {outstanding_invoices.map((invoice, index) => (
                                <TableRow key={index}>
                                    <TableCell className="text-gray-600 text-xs py-1.5">{invoice.created_at}</TableCell>
                                    <TableCell className="text-gray-600 text-xs py-1.5 text-right">{formatToPKR(invoice.discount)}</TableCell>
                                    <TableCell className="text-gray-600 text-xs py-1.5 text-right">{formatToPKR(invoice.tax_amount)}</TableCell>
                                    <TableCell className="text-gray-600 text-xs py-1.5 text-right">{formatToPKR(invoice.total)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>}
        </div>
    )
}

export default CheckInLogs
